import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'
import Vueaxios from 'vue-axios'
import { Loading } from 'element-ui';
import { Message } from 'element-ui';

// var axioes=axios.create({
//   baseURL: 'http://192.168.10.56:3000/',

// })
var loadingInstance: any;
axios.defaults.baseURL = "https://api.xiaobaoev.com/companycar/"

axios.interceptors.request.use(
  config => {
    // loadingInstance = Loading.service({
    //   lock: true,
    //   text: 'Loading',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // })

    if (localStorage.getItem('token')) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
axios.interceptors.response.use(response => {
  // setTimeout(function () {
  //   loadingInstance.close()
  // }, 2000);
  if (response.status === 200) {
    // console.log(response)
    if (response.data.errCode == 40000) {
      Message({ message: response.data.errMsg, type: "error" })
    }
    // iView.Message.success('操作成功');
  }
  return response;
}, error => {
  // if (error.response.status === 422) {
  // // iView.Message.warning(error.response.data.msg);
  // }
  // if (error.response.status === 404) {
  // router.push({
  // name: 'error-404'
  // });
  // }
  // if (error.response.status === 401) {
  // // iView.Message.warning('未获取到登录状态');

  // }
  // setTimeout(function () {
  //   loadingInstance.close()
  // }, 2000)
  Message({ message: error.response, type: "error" })
  return Promise.resolve(error.response);
});

Vue.use(Vueaxios, axios)
Vue.config.productionTip = false;
Vue.use(ElementUI);//引入第三方插件库
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
